import { alpha, makeStyles } from "@material-ui/core";
import {pxToRem} from "@kyburz/kdesign-system/dist/utils/pxToRem";

const disabled = false;
const size = 40;
const sizeOfInputBaseHeight = `${(-18 + size) / 16}rem`;
const sizeOfOptionPaddingTop = pxToRem(size / 4);
const sizeOfOptionHeight = pxToRem(size);
const sizeOfInputHeight = pxToRem(size);
const sizeOfListBoxMaxHeight = `${(size * 6 + 16) / 16}rem`;

export const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: theme.typography.fontFamily,
  },
  title: {
    color: theme.palette.grey[700],
    marginBottom: theme.spacing(1),

    fontFamily: theme.typography.body2.fontFamily,
    fontSize: theme.typography.body2.fontSize,
  },
  popper: {
    position: "relative !important" as "relative",
    minWidth: "12rem",
    width: "auto !important",

    inset: "auto !important",
    transform: "inherit !important",

    zIndex: 10000,

    color: theme.palette.grey[600],
    backgroundColor: theme.palette.common.white,
  },
  popperDisablePortal: {
    position: "relative",
  },
  inputBase: {
    margin: theme.spacing(2),
    width: "calc(100% - 1rem)",
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    [`& input`]: {
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2),
      height: sizeOfInputBaseHeight,
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      fontSize: 14,
      [`&:focus`]: {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  paper: {
    boxShadow: "none",
    margin: 0,
    color: theme.palette.common.black,
    fontSize: "0.813rem",
  },
  option: {
    minHeight: "auto",
    alignItems: "flex-start",
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(2.5),
    paddingTop: sizeOfOptionPaddingTop,
    height: sizeOfOptionHeight,
    [`&[aria-selected="true"]`]: {
      backgroundColor: "transparent",
    },
    [`&[data-focus="true"]`]: {
      backgroundColor: theme.palette.action.hover,
    },
  },
  text: {
    flexGrow: 1,
  },
  textSelected: {
    flexGrow: 1,
    marginLeft: theme.spacing(12.5),
    color: theme.palette.error.main,
  },
  input: {
    height: sizeOfInputHeight,
    fontSize: "0.875rem",
    textOverflow: "ellipsis !important",
    color: theme.palette.grey[700],
    backgroundColor: theme.palette.common.white,
    paddingRight: theme.spacing(4),
    [`&:disabled`]: {
      color: theme.palette.grey[400],
      background: theme.palette.grey[50],
    },
  },
  disabledInput: {
    backgroundColor: theme.palette.grey[50],
  },
  listbox: {
    maxHeight: sizeOfListBoxMaxHeight,
  },
  endAdornment: {
    cursor: "pointer",
  },
  endAdornmentDisabled: {
    cursor: "inherit",
  },
  autosuggestRoot: {
    zIndex: 11,

    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    boxShadow: `0 4px 12px ${alpha(theme.palette.grey[800], 0.4)}`,
  },
  wrapperSelect: {
    position: "relative",
    padding: 0,
    margin: 0,
    width: "100%",
    height: "2.5rem",
    userSelect: "none",
  },
  headerSelect: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    backgroundColor: disabled
      ? theme.palette.grey[50]
      : theme.palette.common.white,
    lineHeight: "1.25rem",
    cursor: disabled ? "deafult" : "pointer",
    paddingRight: theme.spacing(2.5),
  },
  noTitleSelect: {
    whiteSpace: "nowrap",
    color: disabled ? theme.palette.grey[400] : theme.palette.grey[700],
    padding: theme.spacing(2.5, 4),
    lineHeight: 1.429,
    overflow: "hidden",
    height: "2.375rem",
    margin: 0,
    textOverflow: "ellipsis",
    fontSize: "0.875rem",
    boxSizing: "border-box",
  },
  titleSelect: {
    whiteSpace: "nowrap",
    color: disabled ? theme.palette.grey[400] : theme.palette.grey[700],
    padding: theme.spacing(2.5, 4),
    lineHeight: 1.429,
    overflow: "hidden",
    height: "2.375rem",
    margin: 0,
    textOverflow: "ellipsis",
    fontSize: "0.875rem",
    boxSizing: "border-box",
    fontFamily: theme.typography.fontFamily,
  },
  dropDownSelect: {
    position: "absolute",
    margin: 0,
    padding: 0,
    zIndex: 10,
    width: "100%",
    boxShadow: `0 4px 12px ${alpha(theme.palette.grey[800], 0.15)}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
  },
  dropdownControls: {
    borderBottom: "1px solid",
    borderColor: theme.palette.grey[400],
  },
  addingButtonContainer: {
    padding: theme.spacing(2),
  },
  addingFormContainer: {
    padding: theme.spacing(3.75, 5),
  },
  addingFormHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "1rem",
    fontFamily: theme.typography.fontFamily,
  },
  titleContainer: {
    display: "contents",
  },
  flex: {
    display: "flex",
  },
  card: {
    position: "absolute",
    padding: theme.spacing(2.5, 5),
    marginTop: theme.spacing(1.25),

    zIndex: 10,

    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
    boxShadow: `0 4px 12px ${alpha(theme.palette.grey[800], 0.15)}`,
  },
  marginClass: {
    marginTop: theme.spacing(4),
  },
  wrapperAutocomplete: {
    width: "100%",
  },
  outline: {
    borderColor: `${theme.palette.grey[300]} !important`,
  },
  elementContainer: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
  },
  avatar: {
    marginRight: "0.5rem",
  },
}));